import { render, staticRenderFns } from "./AttachmentListItemContent.vue?vue&type=template&id=a1d670f4&lang=pug"
import script from "./AttachmentListItemContent.vue?vue&type=script&lang=ts"
export * from "./AttachmentListItemContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports